/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BoothOptionTemplateDto } from '../../models/booth-option-template-dto';
import { UpdateBoothOptionTemplateDto } from '../../models/update-booth-option-template-dto';

export interface BoothOptionTemplateControllerUpdateV1$Params {
  id: string;
      body: UpdateBoothOptionTemplateDto
}

export function boothOptionTemplateControllerUpdateV1(http: HttpClient, rootUrl: string, params: BoothOptionTemplateControllerUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<BoothOptionTemplateDto>> {
  const rb = new RequestBuilder(rootUrl, boothOptionTemplateControllerUpdateV1.PATH, 'patch');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BoothOptionTemplateDto>;
    })
  );
}

boothOptionTemplateControllerUpdateV1.PATH = '/api/v1/booth-option-template/{id}';
